import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { RootStackParamList } from '../RootStackNavigator/RootStackNavigator';

export const useRootStackNavigation = useNavigation<
  NativeStackNavigationProp<RootStackParamList>
>;
